import JsFunction from './JsFunction';
import ReturnSingleType from './DataTypes/ReturnSingleType';

export default class ReadFunction extends JsFunction {
  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  importModelParameter = [];

  modelNames = [];

  returnType;

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.returnType = new ReturnSingleType(
      htmlDom,
      this.getMapOfEntitiesToAttributes().get(method.entityName) || [],
      this.annotations,
      method.compId
    );
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  readTheUrlAsJsCommad() {
    return `let ${this.entityName}Id = window.location.pathname.replace('/${this.pageName}/','');`;
  }

  printFunction() {
    // first add this should add the inputId parameter code
    // this.functionality += this.returnParametesFromHtmlElements();
    // second  add the apiCallPromisified
    this.functionality += this.readTheUrlAsJsCommad();
    this.functionality += this.apiCallPromisified;

    this.functionality = this.functionality.replace(
      this.functionNextTemplate,
      this.returnType.printFunctionality()
    );
    // third if it exist the next functionName
    //  this.functionality += this.printNextFunctionCode();
    // fourth clear the next template\
    // if (this.nextFunction)
    //   this.functionality.replace(this.functionNextTemplate, this.nextFunction.printFunction());
    this.printNextFunctionCode();
    super.clearfunctionNextTemplate();
    return this.functionality;
  }

  printNextFunctionCode() {
    if (this.nextFunction)
      this.functionality = this.functionality.replace(
        this.functionNextTemplate,
        this.nextFunction.printFunction() + this.functionNextTemplate
      );
  }
}
